const data = [
  {
    key: `collect`,
    question: `How widely and reliably do you COLLECT your customer data?`,
    answers: {
      a: {
        title: `We collect data from a few sources but collection methods are inconsistent—different sources have unrelated tracking plans.`,
        score: 0,
      },
      b: {
        title: `We collect data from a majority of sources but collection methods are inconsistent—different sources have unrelated tracking plans.`,
        score: 1,
      },
      c: {
        title: `We collect data from a few sources, and some of my collection methods are consistent—some sources share a common tracking plan.`,
        score: 1,
      },
      d: {
        title: `We collect data from a majority of our data sources, and most collection methods are consistent—the majority of our sources share a common schema.`,
        score: 2,
      },
      e: {
        title: `We collect data from all sources, and all collection methods are consistent and enforced across a common schema.`,
        score: 3,
      },
      f: {
        title: `Not sure`,
        score: 0,
      },
    },
  },
  {
    key: `synthesize`,
    question: `How consistently do you SYNTHESIZE your customer data into customer profiles and actionable insights?`,
    answers: {
      a: {
        title: `None of my data is synthesized into a single customer view or actionable insights.`,
        score: 0,
      },
      b: {
        title: `Some of my data sources drive a partially unified customer view with limited insights.`,
        score: 1,
      },
      c: {
        title: `Most of my data sources drive a nearly comprehensive customer view that we use to drive actionable insights.`,
        score: 2,
      },
      d: {
        title: `All of my online and offline data sources are unified into a comprehensive customer view that we use to drive actionable insights.
`,
        score: 3,
      },
      e: {
        title: `Not sure`,
        score: 0,
      },
    },
  },
  {
    key: `act`,
    question: `How able are you to ACT on your customer data?`,
    answers: {
      a: {
        title: `I’m unable to take action on my customer data.`,
        score: 0,
      },
      b: {
        title: `I can take basic action on my data, like simple email and in-app message campaigns.`,
        score: 1,
      },
      c: {
        title: `I take sophisticated action on my customer data, including segmented, targeted communications, and retargeting campaigns.`,
        score: 2,
      },
      d: {
        title: `I take advanced action on my customer data by leveraging propensity scores and other predictive models.`,
        score: 3,
      },
      e: {
        title: `Not sure`,
        score: 0,
      },
    },
  },
  {
    key: `adapt`,
    question: `How quickly can you ADAPT with your customer data?`,
    answers: {
      a: {
        title: `I can’t connect new platforms, tools, or user dimensions to my existing data.`,
        score: 0,
      },
      b: {
        title: `It takes substantial effort to connect my customer data to new tools, platforms, and user dimensions/events.`,
        score: 1,
      },
      c: {
        title: `I can easily activate new tools, platforms, and user dimensions/events to my customer data.`,
        score: 2,
      },
      d: {
        title: `I proactively, strategically, and continuously test and activate new tools, platforms, and user dimensions/events to my customer data.`,
        score: 3,
      },
      e: {
        title: `Not sure`,
        score: 0,
      },
    },
  },
]

export default data
